module.exports = __webpack_public_path__ + "img/house-dollar.192e03f5.svg";